import { clsx } from "clsx";
import { ArrowRightIcon } from "lucide-react";
import { ReactNode } from "react";

type Props = {
  children: ReactNode;
  onClick?: () => void;
  className?: string;
};

export const SearchItemWrapper = ({ children, onClick, className }: Props) => {
  return (
    <button
      className={clsx(
        "group flex items-center flex-shrink-0 px-2.5 rounded-xl min-h-10 min-w-0 text-start",
        "hover:bg-neutral-500/5 focus-visible:bg-neutral-500/5 active:bg-neutral-500/10",
        "focus-visible:outline-2 focus-visible:outline-primary-500 focus-visible:outline-offset-0",
        className,
      )}
      onClick={onClick}
    >
      {children}
      <ArrowRightIcon
        size={14}
        className="ms-auto text-neutral-500/50 shrink-0 opacity-0 group-hover:opacity-100 group-focus-visible:opacity-100 rtl:-scale-x-100"
      />
    </button>
  );
};
